import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () =>
      import('./layouts/dash/modules/view-terms-conditions/view-terms-conditions.module').then(
        (m) => m.ViewTermsConditionsModule
      ),
  },
  {
    path: 'policy-privacy',
    loadChildren: () =>
      import('./layouts/dash/modules/view-policy-privacy/view-policy-privacy.module').then(
        (m) => m.ViewPolicyPrivacyModule
      ),
  },
  {
    path: '',
    loadChildren: () =>
      import('./layouts/dash/dash.module').then((m) => m.DashModule),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./layouts/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'register',
    loadChildren: () =>
      import('./layouts/outer/outer.module').then((m) => m.OuterModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
